import { NlpLogGroup } from './types'
import { LegacyLogGroup } from '../typesOld'

export const isNewLogGroup = (log: NlpLogGroup | LegacyLogGroup): log is NlpLogGroup => {
  return !!(log as NlpLogGroup).dbRowDescriptors
}

export const convertToNewLogGroup = (log: LegacyLogGroup): NlpLogGroup => {
  return {
    count: log.count,
    groupingLog: log.groupingLog.map(row => ({
      dbDescriptor: {
        partitionKey: row.partitionKey,
        rowKey: row.rowKey
      }
    })),
    dbRowDescriptors: log.groupingLog.map(row => ({
      partitionKey: row.partitionKey,
      rowKey: row.rowKey
    })),
    lastAdded: log.lastAdded,
    query: log.query
  }
}
